// @ts-nocheck


import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';


import { Batteries as BatteriesComponents } from './../components';
import {
  resetVehicleStatus,
  setVehicleBatteries } from
'./../../../ducks/vehicle';
import { batteryApi } from './../../../lib/api';


const { BatteryForm, EditableItem } = BatteriesComponents;















export class Battery extends Component {
  state = {
    availableBatteries: [],
    isLoading: false
  };

  async componentDidMount() {
    await this.fetchAvailableBatteries();
  }

  fetchAvailableBatteries = async (search) => {
    if (this.props.editable) {
      this.setState({
        isLoading: true
      });
      let availableBatteries = [];
      const result = await batteryApi.fetchBatteries({
        search,
        page: 1,
        pageSize: 50,
        isFree: true,
        nodeId: this.props.employeeBranchOrgUnitId,
        nodeFilterType: 'branchAndChildren'
      });

      if (result) {
        availableBatteries = result.data;
      }
      this.setState({
        availableBatteries,
        isLoading: false
      });
    }
  };

  onAdd = async (battery) => {
    await batteryApi.updateBattery({
      ...battery,
      vehicleId: this.props.vehicleId
    });
    await this.props.resetVehicleStatus(this.props.vehicleId);
    await this.props.setVehicleBatteries(this.props.vehicleId);
    await this.fetchAvailableBatteries();
  };

  onEdit = async (battery) => {
    await batteryApi.updateBattery(battery);
    await this.props.resetVehicleStatus(this.props.vehicleId);
    await this.props.setVehicleBatteries(this.props.vehicleId);
  };

  onRemove = async (battery) => {
    await batteryApi.updateBattery({ ...battery, vehicleId: null });
    await this.props.resetVehicleStatus(this.props.vehicleId);
    await this.props.setVehicleBatteries(this.props.vehicleId);
    await this.fetchAvailableBatteries();
  };

  handleSearch = debounce(
    async (value) => await this.fetchAvailableBatteries(value),
    500
  );
  render() {
    const { items = [], editable } = this.props;
    const { availableBatteries, isLoading } = this.state;
    return (
      <>
        {items.map((item) => {
          if (!item) {
            return null;
          }
          return (
            <EditableItem
              key={item.id}
              battery={item}
              onChange={this.onEdit}
              onRemove={editable ? this.onRemove : null}
              editable={false} // TODO: нужны требования, но пока не можем редактировать АКБ в инвентарной карточке ТС
            />);

        })}
        {editable &&
        <BatteryForm
          onSubmit={this.onAdd}
          handleSearch={this.handleSearch}
          fetchData={this.fetchAvailableBatteries}
          isLoading={isLoading}
          availableBatteries={availableBatteries} />

        }
      </>);

  }
}

export default connect(
  (state) => ({
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }),
  {
    resetVehicleStatus,
    setVehicleBatteries
  }
)(Battery);
